import Image, { ImageProps } from "next/image";
import sunnyDisabledIcon from "assets/icons/sunny-disabled.svg";
import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";
import acceleratedDisabledArrowDown from "assets/icons/accelerated-disabled-arrow-down.svg";

function CardFooter() {
    const stackProps: StackProps = {
        sx: {
            gap: 2,
            padding: 2,
            color: "#9DA4AF",
            flexDirection: "row",
            alignItems: "center",
            borderTop: "1px solid #E3E9EC",
        },
    };

    const imageProps: ImageProps = {
        src: acceleratedDisabledArrowDown,
        alt: "arrow-down",
        width: 40,
        height: 40,
        style: {
            maxWidth: "100%",
            height: "auto",
        },
    };

    const textStackProps: StackProps = {
        sx: {
            gap: 0.5,
            flex: 1,
        },
    };

    const headingStackProps: StackProps = {
        sx: {
            gap: 1,
            flexDirection: "row",
            alignItems: "center",
        },
    };

    const headingImageProps: ImageProps = {
        src: sunnyDisabledIcon,
        alt: "adsum logo",
        style: {
            maxWidth: "100%",
            height: "auto",
        },
    };

    const headingProps: TypographyProps = {
        sx: {
            fontSize: 14,
            fontWeight: 500,
            color: "inherit",
        },
        children: (
            <>
                InstantVAT <span style={{ fontWeight: 600 }}>Faster Refunds</span>
            </>
        ),
    };

    const subHeadingProps: TypographyProps = {
        sx: {
            fontSize: 13,
            color: "inherit",
        },
        children: "Paid out instantly on HMRC verification.",
    };

    return (
        <Stack {...stackProps}>
            <Image {...imageProps} />
            <Stack {...textStackProps}>
                <Stack {...headingStackProps}>
                    <Image {...headingImageProps} />
                    <Typography {...headingProps} />
                </Stack>
                <Typography {...subHeadingProps} />
            </Stack>
        </Stack>
    );
}

export default CardFooter;
